import './polyfill';

import React from 'react';
import ReactDOM from 'react-dom';

import './styles/custom.scss';

import { App } from './App';
import * as serviceWorker from './serviceWorker';




ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();

// This showcase is build on create-react-app which only supports modern
// browsers. Because of that we have to import a polyfill to support
// older browsers like Internet Explorer 9, 10, and 11.

// We decided against using the recommended polyfill react-app-polyfill
// because we wanted to use all the modern features JavaScript has to
// offer.
